var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"backToTop"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.scrolled)?_c('img',{staticClass:"back-to-top",attrs:{"src":require("../assets/images/back-to-top.png")},on:{"click":_vm.handleBackToTop}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }